import React, { useEffect, useRef, useState } from "react";

function ApartmentBlock3({ rooms }) {
  const svgRef = useRef(null);
  const [roomCenters, setRoomCenters] = useState([]);
  const [clickedRoom, setClickedRoom] = useState(null);

  const handleBlockClick = (pathId) => {
    const room = rooms.find((room) => room.top === pathId);
    if (room) {
     
      setClickedRoom({ pathId, status: room.status });
    }
  };

  useEffect(() => {
    if (svgRef.current) {
      const paths = svgRef.current.querySelectorAll("path");
      const centers = Array.from(paths).map((path) => {
        const bbox = path.getBBox();
        const centerX = bbox.x + bbox.width / 2;
        const centerY =
          path.id === "B3 - 01"
            ? 950
            : bbox.y + bbox.height / 2;
       
        return { centerX, centerY, pathId: path.id };
      });
      setRoomCenters(centers);
    }
  }, [rooms]);
  return (
    <div className="relative w-[100%] h-[100%]">
      <svg width="100%" height="100%" viewBox="0 40 1150 1350" ref={svgRef}>
        <path
          id="B3 - 01"
          stroke="#a2a4b4"
          strokeWidth="5"
          transform="scale(1,-1) translate(5, -2200)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 01")}
          fill={
            clickedRoom?.pathId === "B3 - 01"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c1c1cc"
          }
          d="
M510.989227,1313.011230 
	L510.985138,1313.021118 510.928345,1313.513794 510.932068,1313.761719 
	L510.957855,1331.674194 510.815186,1349.341553 511.110962,1367.001343 
	L511.190857,1371.771973 509.901917,1373.145508 505.047974,1373.136108 
	L428.056152,1372.986572 351.063965,1373.032715 274.071838,1373.033325 
	L192.746826,1373.033813 111.421814,1373.034058 30.096804,1373.033203 
	L22.985807,1373.033081 22.983946,1373.028931 22.983761,1366.168945 
	L22.981825,1294.509644 23.038157,1222.850220 22.857513,1151.191406 
	L22.844614,1146.073853 24.180845,1144.759521 29.234674,1144.845825 
	L47.560787,1145.159058 65.895882,1145.022217 84.226219,1144.879272 
	L85.817680,1144.866821 87.399101,1143.565186 89.388290,1142.340088 
	L90.178719,1140.479614 90.893997,1139.143311 90.902069,1137.802734 
	L90.973907,1125.875122 90.920723,1113.946655 90.904381,1102.018311 
	L92.471863,1101.685425 94.039261,1101.061523 95.606873,1101.060913 
	L193.069992,1101.027832 290.533112,1101.045776 388.482910,1101.546631 
	L388.980286,1121.816406 389.096680,1141.599609 388.920044,1161.380005 
	L388.880737,1165.782715 390.368866,1167.175781 394.695221,1167.086182 
	L405.994537,1166.852417 417.301880,1167.005249 428.606018,1167.005127 
	L439.577698,1167.005127 450.549469,1167.029297 461.520996,1166.988281 
	L463.741913,1166.979980 466.713928,1167.598145 465.540009,1163.104614 
	L465.603577,1155.074219 465.670959,1147.471802 466.229156,1139.910034 
	L480.805756,1139.983398 494.891602,1140.016357 508.981384,1140.514648 
	L508.989868,1144.307129 508.998322,1147.634033 508.998352,1150.960938 
	L508.998779,1203.193115 508.978546,1255.425415 509.081116,1307.657471 
	L509.084625,1309.443970 510.318298,1311.228149 510.978577,1313.013428 
	L510.978577,1313.013428 510.993317,1313.001343 510.989227,1313.011230 
z"
        />
        <path
          id="B3 - 02"
          stroke="#a2a4b4"
          strokeWidth="5"
          transform="translate(5, 0)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 02")}
          fill={
            clickedRoom?.pathId === "B3 - 02"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c1c1cc"
          }
          d="
M510.989227,1313.011230 
	L510.985138,1313.021118 510.928345,1313.513794 510.932068,1313.761719 
	L510.957855,1331.674194 510.815186,1349.341553 511.110962,1367.001343 
	L511.190857,1371.771973 509.901917,1373.145508 505.047974,1373.136108 
	L428.056152,1372.986572 351.063965,1373.032715 274.071838,1373.033325 
	L192.746826,1373.033813 111.421814,1373.034058 30.096804,1373.033203 
	L22.985807,1373.033081 22.983946,1373.028931 22.983761,1366.168945 
	L22.981825,1294.509644 23.038157,1222.850220 22.857513,1151.191406 
	L22.844614,1146.073853 24.180845,1144.759521 29.234674,1144.845825 
	L47.560787,1145.159058 65.895882,1145.022217 84.226219,1144.879272 
	L85.817680,1144.866821 87.399101,1143.565186 89.388290,1142.340088 
	L90.178719,1140.479614 90.893997,1139.143311 90.902069,1137.802734 
	L90.973907,1125.875122 90.920723,1113.946655 90.904381,1102.018311 
	L92.471863,1101.685425 94.039261,1101.061523 95.606873,1101.060913 
	L193.069992,1101.027832 290.533112,1101.045776 388.482910,1101.546631 
	L388.980286,1121.816406 389.096680,1141.599609 388.920044,1161.380005 
	L388.880737,1165.782715 390.368866,1167.175781 394.695221,1167.086182 
	L405.994537,1166.852417 417.301880,1167.005249 428.606018,1167.005127 
	L439.577698,1167.005127 450.549469,1167.029297 461.520996,1166.988281 
	L463.741913,1166.979980 466.713928,1167.598145 465.540009,1163.104614 
	L465.603577,1155.074219 465.670959,1147.471802 466.229156,1139.910034 
	L480.805756,1139.983398 494.891602,1140.016357 508.981384,1140.514648 
	L508.989868,1144.307129 508.998322,1147.634033 508.998352,1150.960938 
	L508.998779,1203.193115 508.978546,1255.425415 509.081116,1307.657471 
	L509.084625,1309.443970 510.318298,1311.228149 510.978577,1313.013428 
	L510.978577,1313.013428 510.993317,1313.001343 510.989227,1313.011230 
z"
        />
        <path
          id="B3 - 03"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-2, 18)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 03")}
          fill={
            clickedRoom?.pathId === "B3 - 03"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#52535F"
          }
          d="
M1061.928833,491.816345 
	L1023.466431,492.359406 985.046997,492.404510 946.627563,492.454010 
	L940.806396,492.461487 934.985229,492.489349 928.720947,492.534363 
	L928.183838,480.236084 927.918884,467.908936 928.086243,455.587616 
	L928.147034,451.114929 926.536926,449.902191 922.258545,449.924408 
	L894.098206,450.070648 865.936768,449.999725 837.775696,449.998810 
	L830.000488,449.998566 829.998047,449.997375 829.997986,442.455475 
	L829.997314,377.801666 829.998779,313.147888 829.997131,248.494080 
	L829.995667,192.728134 829.990967,136.962189 829.987854,81.196236 
	L829.987488,75.445961 830.227051,69.682335 829.906738,63.949970 
	L829.682129,59.930428 831.090881,58.885452 835.000854,58.908424 
	L861.494690,59.064125 887.989807,58.989006 914.484558,58.988995 
	L961.808472,58.988968 1009.132446,59.020241 1056.456177,58.929619 
	L1060.167480,58.922508 1062.114990,59.272675 1062.110596,63.905735 
	L1061.974609,206.377029 1061.984375,348.848450 1061.928833,491.816345 
z"
        />
        <path
          id="B3 - 04"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-1, 20)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 04")}
          fill={
            clickedRoom?.pathId === "B3 - 04"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#52535F"
          }
          d="
M511.072388,459.954437 
	L511.066437,458.911957 511.060516,457.869476 511.448730,456.325562 
	L512.224121,454.641296 512.936340,453.459045 512.938416,452.275543 
	L512.998169,417.824280 513.008362,383.372772 512.906555,348.921692 
	L512.902649,347.597351 511.711273,346.276520 511.073212,344.954071 
	L511.064636,343.911255 511.056091,342.868408 511.061737,341.435974 
	L511.713196,339.220978 512.898926,337.397705 512.905945,335.569916 
	L513.021240,305.575378 512.987793,275.580322 512.987793,245.585358 
	L512.987793,185.595459 512.987366,125.605545 512.988464,65.615639 
	L512.988586,58.996162 512.992615,58.989052 519.330933,58.988914 
	L592.485291,58.987370 665.639709,59.045326 738.793640,58.865788 
	L743.932373,58.853172 745.131653,60.235874 745.115662,65.255302 
	L744.932983,122.411766 745.125000,179.569382 744.965759,236.725983 
	L744.772827,306.006622 744.294006,375.286438 744.114075,444.567078 
	L744.102417,449.060852 742.806396,450.126068 738.472656,450.097534 
	L710.145325,449.910706 681.815430,450.097534 653.488220,449.902283 
	L649.096924,449.872040 647.769592,451.015259 647.879272,455.471497 
	L648.178528,467.628326 647.967834,479.797668 647.938599,492.415771 
	L603.267944,492.904205 558.617859,492.938904 513.488953,492.501221 
	L513.002563,482.806732 513.079224,473.582947 512.901917,464.364075 
	L512.873474,462.883026 511.710785,461.423767 511.072388,459.954437 
z"
        />

        <path
          fill="#9290A2"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-160, 26) scale(1.2 ,0.89)"
          d="
M752.058777,69.023605 
	L752.058838,65.228455 752.058838,61.929482 752.058838,58.312382 
	L753.733704,58.096016 754.992615,57.793415 756.251831,57.791607 
	L776.897888,57.761951 797.544556,57.850262 818.189453,57.696182 
	L821.900269,57.668484 823.026245,58.765392 823.019226,62.512794 
	L822.912781,118.956253 822.947510,175.399963 822.934143,231.843628 
	L822.933899,232.981628 822.754272,234.119598 822.624756,235.656250 
	L799.267456,235.656250 776.071289,235.656250 752.058716,235.656250 
	L752.058716,180.260345 752.058716,124.890060 752.058777,69.023605 
z"
        />
        <text
          textAnchor="middle"
          fontSize="20"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="785" y="165">
            CORE
          </tspan>
        </text>

        <path
          id="B3 - 05"
          stroke="#a2a4b4"
          strokeWidth="5"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 05")}
          fill={
            clickedRoom?.pathId === "B3 - 05"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#C3BECD"
          }
          d="
M1062.013916,1372.554932 
	L986.284607,1373.028931 910.549622,1372.995850 834.814941,1373.124268 
	L830.351196,1373.131836 828.811707,1372.109985 828.892029,1367.368530 
	L829.182373,1350.229126 829.004333,1333.081665 829.297363,1315.224731 
	L830.050049,1312.114136 830.917603,1309.714478 830.907288,1307.318359 
	L830.648010,1247.211792 830.159607,1187.105957 829.998535,1126.999268 
	L829.830261,1064.185303 829.960571,1001.370422 829.962524,938.555969 
	L829.962769,931.961365 829.969543,931.956482 836.340210,931.954651 
	L849.003113,931.950928 861.666016,931.975464 874.328796,931.938232 
	L877.694092,931.928406 877.693848,931.844971 878.115112,928.560303 
	L878.164124,902.853760 878.165405,877.617310 878.224121,852.380920 
	L878.246155,842.924744 878.401550,833.468811 878.496155,824.012756 
	L882.663391,823.673828 886.830078,823.047791 890.997864,823.040527 
	L932.992859,822.967285 974.988220,823.045532 1016.983154,822.956909 
	L1026.462891,822.936951 1035.940308,822.314331 1045.421387,822.210693 
	L1049.543335,822.165527 1053.742920,822.379639 1057.762695,823.191772 
	L1059.369507,823.516357 1061.011719,825.556702 1061.846802,827.214478 
	L1062.517944,828.546814 1062.003906,830.479675 1062.003906,832.146057 
	L1062.005981,1012.125244 1062.007080,1192.104492 1062.013916,1372.554932 
z"
        />
        <path
          id="B3 - 06"
          stroke="#a2a4b4"
          strokeWidth="5"
          transform="translate(0, 10)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 06")}
          fill={
            clickedRoom?.pathId === "B3 - 06"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#E9E2E9"
          }
          d="
M828.087097,752.010620 
	L828.391418,749.934143 828.960144,747.857849 828.961609,745.781189 
	L829.007812,680.635498 829.054993,615.489685 828.886292,550.344421 
	L828.873413,545.382629 829.968872,543.862183 835.169495,543.911926 
	L863.824341,544.185791 892.483093,544.043335 921.140564,544.041687 
	L928.945740,544.041260 928.946594,544.038208 928.947083,535.985168 
	L928.947754,525.488525 929.060974,514.989990 928.881348,504.496460 
	L928.822510,501.055145 929.862122,499.889954 933.400757,499.898773 
	L974.887085,500.002045 1016.374084,500.031250 1057.860107,499.878754 
	L1062.800781,499.860596 1063.090210,502.304840 1063.087158,506.112518 
	L1063.025513,582.921082 1063.040649,659.729675 1063.040161,736.538269 
	L1063.039917,760.863770 1062.973877,785.189636 1063.102783,809.514404 
	L1063.123901,813.494324 1062.063110,815.157837 1057.764771,815.148071 
	L998.284912,815.012939 938.804871,815.017273 878.807007,814.500854 
	L878.270508,809.550476 878.264099,805.086792 878.231018,800.623169 
	L878.118286,785.421814 877.996155,770.220459 878.109253,754.799438 
	L876.926208,753.830566 875.573059,752.661316 874.080627,752.442749 
	L872.363708,752.191284 870.519775,753.000122 868.737671,752.968750 
	L857.694885,752.774475 846.653992,752.474243 835.612427,752.206970 
	L833.103882,752.146179 830.595520,752.076294 828.087097,752.010620 
z"
        />
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-69, 15) scale(1.08 ,1)"
          d="
M920.970825,460.215668 
	L920.974670,484.182678 920.958862,507.675110 921.001221,531.167419 
	L921.006348,534.020447 921.155945,536.264099 917.011597,536.242371 
	L888.688232,536.093689 860.363770,536.162109 832.039612,536.143311 
	L831.235657,536.142761 830.431824,535.949707 829.265259,535.799805 
	L829.265259,509.294220 829.265259,482.930298 829.265259,456.254974 
	L830.932434,456.140198 832.384583,455.953979 833.836914,455.953064 
	L861.161438,455.935791 888.485901,455.945374 915.810425,455.932861 
	L918.506531,455.931641 921.481995,455.443787 920.970825,460.215668 
z"
        />
        <text
          textAnchor="middle"
          fontSize="15"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="875" y="500">
            SERVICE
          </tspan>
          <tspan x="875" y="530">
            CORE
          </tspan>
        </text>
        <path
          id="B3 - 07"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(0, 10)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B3 - 07")}
          fill={
            clickedRoom?.pathId === "B3 - 07"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#52535F"
          }
          d="
M517.590576,946.723022 
	L517.634460,904.407410 517.631042,862.091553 517.790527,819.776367 
	L517.807739,815.199951 515.358093,814.984741 511.640137,815.303223 
	L511.175079,815.070251 511.104645,814.859436 511.303741,814.035278 
	L511.713409,811.779907 511.975922,810.137817 511.976227,808.495789 
	L511.995789,708.564636 511.999023,608.633484 511.954712,508.702332 
	L511.953888,506.796234 511.367218,504.890411 511.053894,502.984467 
	L510.815948,499.493317 513.326843,499.989441 515.446411,499.987915 
	L531.080017,499.976746 546.713684,499.979767 562.347290,499.979797 
	L589.124023,499.979828 615.901245,500.060455 642.677002,499.896942 
	L646.757141,499.872040 648.141052,500.939911 648.047302,505.166718 
	L647.781921,517.135376 647.961121,529.114014 648.070374,541.952209 
	L650.016174,543.210205 651.856018,543.943542 653.697632,543.948242 
	L682.011414,544.021362 710.325745,544.068909 738.638916,543.920837 
	L742.606140,543.900146 744.102478,544.748535 744.098328,549.094299 
	L743.983826,667.679688 743.984985,786.265076 744.095215,904.850464 
	L744.099182,909.115662 742.736572,910.107239 738.693359,910.085205 
	L710.047180,909.929199 681.399353,910.070984 652.753052,909.927917 
	L648.494751,909.906677 646.769531,911.079834 646.918884,915.575806 
	L647.206177,924.226929 646.747498,932.905090 647.107666,941.550781 
	L647.294922,946.046326 645.840454,947.114075 641.486511,947.096130 
	L601.847717,946.932312 562.207947,947.003418 522.568420,946.988342 
	L520.909119,946.987671 519.249878,946.815369 517.590576,946.723022 
z"
        />
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-69, 15) scale(1.09 ,1.001)"
          d="
M745.842590,535.904785 
	L737.194580,536.012451 728.546692,536.192871 719.898438,536.213135 
	L699.923584,536.259888 679.948486,536.228943 659.973511,536.229553 
	L658.174011,536.229614 656.374512,536.229553 653.695190,536.229553 
	L653.695190,521.509644 653.695190,507.266663 653.729248,492.115173 
	L653.735901,479.807922 653.708557,468.409180 653.681152,457.010437 
	L654.896667,456.653900 656.111633,455.988556 657.327820,455.986145 
	L685.867981,455.929474 714.408264,455.940399 742.948486,455.967194 
	L743.746399,455.967957 744.544128,456.279083 745.638794,457.190674 
	L745.904602,483.925507 745.873596,509.915161 745.842590,535.904785 
z"
        />
        <text
          textAnchor="middle"
          fontSize="15"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="693" y="500">
            SERVICE
          </tspan>
          <tspan x="693" y="530">
            CORE
          </tspan>
        </text>
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-10, 15) scale(1.02 ,1)"
          d="
M746.000000,1307.994873 
	L669.553345,1307.994751 593.606750,1307.994751 517.091370,1307.994751 
	L516.966919,1305.902710 516.772583,1304.155029 516.772034,1302.407471 
	L516.756165,1249.761475 516.813538,1197.115356 516.661499,1144.469727 
	L516.648682,1140.043701 517.867737,1138.891846 522.259033,1138.897461 
	L620.553589,1139.021118 718.848450,1139.024292 817.143005,1138.897339 
	L821.830994,1138.891235 823.041809,1140.345947 823.029907,1144.872559 
	L822.892883,1197.185059 822.865112,1249.498169 823.056396,1301.810425 
	L823.075562,1307.060303 821.368896,1308.154175 816.471680,1308.103271 
	L793.149902,1307.860840 769.824280,1307.994873 746.000000,1307.994873 
z"
        />
        <text
          textAnchor="middle"
          fontSize="25"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="670" y="1240">
            CORE
          </tspan>
        </text>
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-65, 5) scale(1.08 ,1)"
          d="
M871.146729,913.960327 
	L871.005676,924.584534 872.403564,923.159790 862.452942,923.239990 
	L853.294617,923.313843 844.125061,922.999207 834.980408,923.360413 
	L830.243958,923.547424 828.780029,922.234436 828.805603,917.338745 
	L829.005066,879.207458 828.916321,841.074707 828.916565,802.942383 
	L828.916626,790.619446 828.916504,778.296570 828.916443,765.973633 
	L828.916443,764.190552 828.916443,762.407471 828.916443,760.319031 
	L843.083740,760.319031 856.660583,760.319031 871.146545,760.319031 
	L871.146545,811.402588 871.146545,862.434265 871.146729,913.960327 
z"
        />
        <text
          textAnchor="middle"
          fontSize="12"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="850" y="800">
            SERVICE
          </tspan>
          <tspan x="850" y="830">
            CORE
          </tspan>
        </text>
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-39, 0) scale(1.05 ,1)"
          d="
M745.945068,946.000000 
	L745.946228,973.980652 745.955139,1001.461243 745.943604,1028.941895 
	L745.940186,1036.981201 745.913574,1036.980225 737.980164,1036.980103 
	L711.998474,1036.979736 686.016785,1036.980225 660.035095,1036.980347 
	L658.240662,1036.980347 656.446228,1036.980469 654.269165,1036.980469 
	L654.269165,996.944519 654.269165,957.387573 654.269165,917.205505 
	L655.744751,917.103088 657.325195,916.899048 658.905701,916.897827 
	L686.053223,916.877014 713.201355,916.969788 740.347656,916.790955 
	L744.775940,916.761780 746.185730,918.171082 746.023193,922.519165 
	L745.737244,930.169739 745.944336,937.838745 745.945068,946.000000 
z"
        />
        <text
          textAnchor="middle"
          fontSize="15"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="698" y="970">
            SERVICE
          </tspan>
          <tspan x="698" y="1000">
            CORE
          </tspan>
        </text>
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          d="
M642.859009,953.868103 
	L644.648376,953.951721 645.954590,954.035217 647.628052,954.142212 
	L647.628052,981.675171 647.628052,1009.026672 647.628052,1036.677612 
	L604.095398,1036.677612 560.744995,1036.677612 517.080322,1036.677612 
	L517.080322,1009.152405 517.080322,981.931396 517.080322,953.867981 
	L558.942078,953.867981 600.658875,953.867981 642.859009,953.868103 
z"
        />
        <text
          textAnchor="middle"
          fontSize="18"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="580" y="1000">
            CORE
          </tspan>
        </text>
        <path
          fill="#9391A3"
          stroke="#2a2d30"
          strokeWidth="5"
          transform="translate(-80, -55) scale(1.2 ,1.05)"
          d="
M459.059814,1121.000000 
	L459.059875,1134.116211 459.059875,1146.732544 459.059875,1159.684937 
	L438.302399,1159.684937 418.066925,1159.684937 397.407227,1159.684937 
	L397.407227,1119.001099 397.407227,1078.323608 397.407227,1037.288818 
	L417.722626,1037.288818 437.949982,1037.288818 459.059753,1037.288818 
	L459.059753,1065.053833 459.059753,1092.776978 459.059814,1121.000000 
z"
        />
        <text
          textAnchor="middle"
          fontSize="15"
          stroke="black"
          strokeWidth="0.5"
          fontFamily="Arial"
        >
          <tspan x="433" y="1090">
            SERVICE
          </tspan>
          <tspan x="430" y="1110">
            CORE
          </tspan>
        </text>
        {rooms?.map((roomSec, index) => {
         
          const { unit, room } = roomSec;
          const roomCenter = roomCenters.find(
            (center) => center.pathId === roomSec.top
          );

          return (
            roomCenter && (
              <text
                key={index}
                x={roomCenter.centerX}
                y={roomCenter.centerY}
                fontSize="25"
                fill="black"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="bold"
              >
                <tspan x={roomCenter.centerX} dy="-0.8em">
                  {unit}
                </tspan>
                <tspan x={roomCenter.centerX} dy="2em">
                  {room}
                </tspan>
              </text>
            )
          );
        })}
      </svg>
    </div>
  );
}

export default ApartmentBlock3;
